var staticDayTime = require('./staticDayTime')

var staticWeekTime = staticDayTime * 7

module.exports = staticWeekTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticWeekTime.js
// module id = 3Cr9
// module chunks = 137